import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Sound: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m570 480v-180h-30v150c0 16.57 13.43 30 30 30z' />
    <path d='m630 510v-240h-30v210c0 16.57 13.43 30 30 30z' />
    <path d='m484.94 623.69c-5.7 0-11.32-1.98-15.94-5.83l-125.25-104.38c-2.69-2.24-6.1-3.48-9.6-3.48h-184.14v-240h184.14c3.5 0 6.91-1.23 9.6-3.48l125.25-104.38c7.53-6.28 17.73-7.59 26.61-3.43s14.4 12.83 14.4 22.64v417.3c0 9.81-5.52 18.48-14.4 22.64-3.44 1.61-7.07 2.4-10.67 2.4zm-304.94-143.69h154.14c10.51 0 20.74 3.7 28.81 10.43l117.05 97.54v-395.94l-117.05 97.54c-8.07 6.73-18.3 10.43-28.81 10.43h-154.14z' />
  </IconBase>
));

Sound.displayName = 'Sound';

export default Sound;
